"use client";

import { c as _c } from "react/compiler-runtime";
import InteractiveMediaLoadGate from "@/components/drops/media/InteractiveMediaLoadGate";
import { useEffect, useMemo, useState } from "react";
import NFTImage from "@/components/nft-image/NFTImage";
import { getMediaType } from "@/components/nft-image/utils/media-type";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import useDeviceInfo from "@/hooks/useDeviceInfo";
interface NowMintingArtworkProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingArtwork(t0) {
  const $ = _c(13);
  const {
    nft
  } = t0;
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t1;
  if ($[0] !== nft) {
    t1 = getMediaType(nft, true);
    $[0] = nft;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isHtml = t1 === "html";
  const [hasMounted, setHasMounted] = useState(false);
  const shouldGate = hasTouchScreen && isHtml;
  const [interactiveEnabled, setInteractiveEnabled] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setHasMounted(true);
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setInteractiveEnabled(false);
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== nft.id || $[6] !== shouldGate) {
    t5 = [nft.id, shouldGate];
    $[5] = nft.id;
    $[6] = shouldGate;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t4, t5);
  let shouldAnimate = true;
  if (isHtml) {
    shouldAnimate = hasMounted && (interactiveEnabled || !shouldGate);
  }
  let t6;
  if ($[8] !== interactiveEnabled || $[9] !== nft || $[10] !== shouldAnimate || $[11] !== shouldGate) {
    t6 = <div className="tw-flex tw-w-full tw-items-start tw-justify-center">{shouldGate && !interactiveEnabled ? <InteractiveMediaLoadGate onLoad={() => setInteractiveEnabled(true)} ariaLabel="Load interactive artwork" className="tw-w-full"><NFTImage nft={nft} animation={shouldAnimate} height={650} transparentBG={true} showBalance={false} /></InteractiveMediaLoadGate> : <div className="tw-relative tw-w-full"><NFTImage nft={nft} animation={shouldAnimate} height={650} transparentBG={true} showBalance={false} /></div>}</div>;
    $[8] = interactiveEnabled;
    $[9] = nft;
    $[10] = shouldAnimate;
    $[11] = shouldGate;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}